import React from 'react';

import {memo} from '_/utilities/memo';

import {Header, StyledListSection} from './styles';

export interface Props {
  className?: string;
  header: string;
  title?: string;
}

export function ListSectionComponent({
  header,
  className,
  title,
}: Props): React.ReactElement {
  return (
    <div className={className} title={title} aria-hidden>
      <Header>{header}</Header>
    </div>
  );
}

export default memo(ListSectionComponent, StyledListSection);
